export default __webpack_public_path__ + "4f26c079cc22da3c0515aa552cc9c08a.png";